import {
    BorderRadiusExtraSmall,
    ColorNeutralGrey3,
    ColorOpacityOnLightHover,
    Spacing8
} from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

const FilterTagContainer = styled.button`
    display: flex;
    height: 25px;
    align-items: center;
    padding: 0 ${Spacing8};
    border: 1px solid ${ColorNeutralGrey3};
    background-color: transparent;
    border-radius: ${BorderRadiusExtraSmall};
    white-space: nowrap;

    &:hover {
        background-color: ${ColorOpacityOnLightHover};
    }
`;

const StyledIcon = styled(Icon)`
    width: 14px;
    height: 14px;
`;

export default function FilterTag(props: ComponentPropsWithoutRef<'button'>) {
    const { children } = props;

    return (
        <FilterTagContainer {...props}>
            <WithIcon icon={<StyledIcon type="Close" size={16} />} position="right">
                <Typography.Body as="span" size="S">
                    {children}
                </Typography.Body>
            </WithIcon>
        </FilterTagContainer>
    );
}
